import SectionHeader from '../SectionHeader';

const SectionBox = ({ title, children, testid = '' }) => {
  return (
    <div
      className='mb-6 rounded-md border border-slate-300 p-4'
      data-cy={testid}
    >
      <div className='pb-6'>
        <SectionHeader>{title}</SectionHeader>
      </div>

      {children}
    </div>
  );
};

export default SectionBox;
